/**
 * This replaces the legacy count down.
 */

require('../public/css/flipclock.css')
const api = require('./api')
const momentTimezone = require('moment-timezone')
const debug = require('debug')('streamspot:countdown')
const query = require('./util').qs(window)
let offset = query['offset'] ? query['offset'] : null

/*
  use title if set
 */
if (query['title']) {
  const title = query['title']
  $('#countdown-header').text(title)
} else {
  $('#countdown-header').text('Next Live Broadcast:')
}

/**
 * The inverse query will inverse the colors on the countdown
 */
if (query['inverse']) {
  $('body').addClass('inverse')
}

if ( window.isBroadcasting == 1 ) {
  /**
   * when broadcasting, show live button instead of watch-on-demand-button
  */
  debug('countdown: isBroadcasting triggered %s', window.isBroadcasting)
  $('#options').fadeIn()
  $('#watch-on-demand-button').hide()
  $('#live-button').css('display', 'block')
} else if (!query['excludeLink']) {
  $('html').mouseenter(() => {
    $('#options').fadeIn()
  })

  $('html').mouseleave(() => {
    $('#options').fadeOut()
  })
}

debug('countdown: getting upcoming broadcasts')
if (window.ssId) {
  api.getUpcomingBroadcasts(window.ssId, (data) => {
    if (!data || !data.next) {
      debug('getUpcomingBroadcasts: A next broadcast was NOT found.')
      initZeroCountown()
      return
    }
    debug('getUpcomingBroadcasts: A next broadcast was found: %s', data.next.countdown_text)
    initCountown(data.next)
  })
} else {
  initZeroCountown()
}

function initCountown(nextBroadcast) {
  debug('initCountown: start')
  const timeOfBroadcast = momentTimezone.tz(nextBroadcast.start, nextBroadcast.timezone)
  if (offset) {
    timeOfBroadcast.add(offset, 's')
  }
  const utcOffset = new Date().getTimezoneOffset()
  const nextBroadcastTime = timeOfBroadcast.utcOffset(utcOffset).toDate()
  debug('initCountown: Seconds until next time: %s', nextBroadcastTime)
  startCountown(nextBroadcastTime)
  debug('initCountown: end')
}

function startCountown(date) {
  $('#the-clock').countdown(date, function (event) {
    $(this).html(event.strftime(timeTemplate()))
  })
}

function initZeroCountown() {
  debug('initZeroCountown: start')
  $('#the-clock').countdown(0, function (event) {
    $(this).html(event.strftime(timeTemplate()))
  })
  debug('initZeroCountown: end')
}

function timeTemplate() {
  return `
  <div class='unit'>
    <div class='number'>%D</div>
    <div class='text'>Days</div>
  </div>
  <div class='unit'>
    <div class='number'>%H</div>
    <div class='text'>Hours</div>
  </div>
  <div class='unit'>
    <div class='number'>%M</div>
    <div class='text'>Mins</div>
  </div>
  <div class='unit'>
    <div class='number'>%S</div>
    <div class='text'>Secs</div>
  </div>
  `
}



// WEBPACK FOOTER //
// ./src/countdown.js